import Main from "layouts/Main";
import React, { FC } from "react";
import { useParams } from "react-router-dom";
import DetailOrder from "components/OrderManage/InprocessDeliveryTabsCard/DetailOrder";

const OrderLotbyIdPage: FC = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <Main namePage="รายละเอียดล็อตสินค้า">
      <div className="layout-content">
        <DetailOrder id={id ?? ""} />
      </div>
    </Main>
  );
};

export default OrderLotbyIdPage